module.exports = __webpack_public_path__ + "img/tree.c5361721.jpg";